import { PeopleTypes } from "enums/peopleTypes";
import { useCopyRosterFromSeasonToSeason } from "hooks/useRosterCopyApi";
import { useCopyStaffFromSeasonToSeason } from "hooks/useStaffCopyApi";

type Props = {
  type: PeopleTypes;
  entityId: string;
  seasonId: string;
  fromSeasonId: string;
};

export const useCopyPeople = ({ type, entityId, seasonId, fromSeasonId }: Props) => {
  const { mutateAsync: copyRoster, isPending: isRosterCopying } = useCopyRosterFromSeasonToSeason();
  const { mutateAsync: copyStaff, isPending: isStaffCopying } = useCopyStaffFromSeasonToSeason();

  const mutateAsync =
    type === PeopleTypes.Roster
      ? () => copyRoster({ entityId, seasonId, fromSeasonId })
      : type === PeopleTypes.Staff
        ? () => copyStaff({ entityId, seasonId, fromSeasonId })
        : () => {};

  return { isCopying: isRosterCopying || isStaffCopying, mutateAsync };
};
